
import React from 'react'
import { InfoContainer, InfoWrapper, InfoRow, Column1,TopLine, TextWrapper,
   Boldtitle, Heading, Subtitle, Column2, Img, Column3 } from './ProblemElements'
import { useTranslation } from 'react-i18next';



function ProblemSection({lightBg, imgStart, topLine,
  lightText,  description,bolddes,  darkText, Icon1, id, alt,
  description2, bolddes2, Icon2, topLine2,
  description3, bolddes3, Icon3, topLine3}) {
    const {t} = useTranslation();

  return (
		<>
		<InfoContainer lightBg={lightBg} id={id}>
			<InfoWrapper>
        <InfoRow imgStart={imgStart}>
          <Column1>
            <Heading>{t("problem.head")}</Heading>
            <TextWrapper>
              <Img lightText={lightText}  src={Icon1} alt={alt} />
              <Subtitle darkText={darkText} >{description}</Subtitle>		
              <Boldtitle>{t("problem.bolddes")}</Boldtitle>	
              <TopLine>{t("problem.topLine")}</TopLine>			
            </TextWrapper>
          </Column1>
          <Column2>
            <TextWrapper>
              <Img lightText={lightText}  src={Icon2} alt={alt} />
              <Subtitle darkText={darkText} >{description2}</Subtitle>		
              <Boldtitle>{t("problem.bolddes2")}</Boldtitle>	
              <TopLine>{t("problem.topLine2")}</TopLine>			
            </TextWrapper>
          </Column2>
          <Column3>
            <TextWrapper>
              <Img lightText={lightText}  src={Icon3} alt={alt} />
              <Subtitle darkText={darkText} >{description3}</Subtitle>		
              <Boldtitle>{t("problem.bolddes3")}</Boldtitle>	
              <TopLine>{t("problem.topLine3")}</TopLine>			
            </TextWrapper>
          </Column3>
        </InfoRow>
			</InfoWrapper>
		</InfoContainer>	
		</>
	)
}

export default ProblemSection
